/* eslint-disable react/no-danger */

/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useCallback, useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import useScrollToTop from '../../hooks/useScrollToTop';
import * as AppPropTypes from '../../lib/PropTypes';

import Blocks from '../blocks/Blocks';
import DocumentBlock from '../blocks/Document';
import Header from '../headers/Article';
import Author from '../partials/Author';
import Title from '../partials/PageTitle';

import styles from '../../../styles/pages/article.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ArticlePage = ({ page, className }) => {
    const {
        title: articleTitle = null,
        image: articleImage = null,
        author = null,
        publishedAt = null,
        blocks = [],
        document = null,
    } = page || {};

    useScrollToTop(page);

    const headerRef = useRef();
    const onHandleScroll = useCallback(
        (e) => {
            e.preventDefault();
            const { height: headerHeight } = headerRef.current.getBoundingClientRect();
            window.scrollTo({
                top: headerHeight,
                // behavior: 'smooth',
            });
        },
        [headerRef],
    );

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.hasHeader]: articleImage !== null,
                },
            ])}
        >
            {articleImage !== null ? (
                <div ref={headerRef} className={styles.header}>
                    <Header
                        title={articleTitle}
                        image={articleImage}
                        onButtonClick={onHandleScroll}
                    />
                </div>
            ) : null}
            {articleImage === null && articleTitle !== null ? (
                <Title className={styles.title} title={articleTitle} />
            ) : null}
            {author !== null ? (
                <Author className={styles.author} author={author} date={publishedAt} />
            ) : null}
            {blocks !== null ? (
                <Blocks blocks={blocks} isContainer containerClassName={styles.blocks} />
            ) : null}
            {document !== null ? (
                <div className={styles.document}>
                    <DocumentBlock
                        document={document}
                        label={
                            <FormattedMessage
                                defaultMessage="Download the press release (pdf)"
                                description="Button label"
                            />
                        }
                        isContainer
                    />
                </div>
            ) : null}
        </div>
    );
};
ArticlePage.propTypes = propTypes;
ArticlePage.defaultProps = defaultProps;

export default ArticlePage;
